import axios from "axios";
import { jwtDecode } from "jwt-decode";
const API_URL = process.env.REACT_APP_API_URL;

const login = async (username: string, password: string) => {
  console.log("This is the env API " + API_URL);
  try {
    const response = await axios.post(`${API_URL}/login`, {
      username,
      password,
    });
    const { access_token } = response.data;
    localStorage.setItem("token", access_token);

    const decoded: any = jwtDecode(access_token);
    return {
      token: access_token,
      name: decoded.name,
      username: decoded.username,
    };
  } catch (error) {
    throw error;
  }
};

const logout = () => {
  localStorage.removeItem("token");
};

const getToken = () => {
  return localStorage.getItem("token");
};

const isAuthenticated = () => {
  return !!getToken();
};

const authService = {
  login,
  logout,
  getToken,
  isAuthenticated,
};

export default authService;
